import { HttpClient } from "@angular/common/http";
import { Injectable } from '@angular/core';
import { environment } from "../../../../../../environments/environment";

@Injectable()
export class MemberInfoService {

    constructor(private http: HttpClient) { }


    getMemberInfo(isInvited,email) {
        return this.http.get(environment.BASE_URL_HRD +
            'tmMng/getMemberInfoByEmail/' +  isInvited + '/' + email)
    }

}
